import React from 'react';
import UploadedImage from './UploadedImage.jsx';
import UploadInputSvg from './UploadInputSvg.jsx';

const UploaderBackground = (props) => {
    if (props.path !== null && props.loading !== true) {
        return (
        <UploadedImage path={props.path}/>
        )
    } else {
        return (<UploadInputSvg />)
    }
};

export default UploaderBackground;




// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/UploaderBackground.jsx